import "./style.scss";
import $ from 'jquery';

function moveArrows() {
    const leftMargin = $('.slider-with-round-image-over__slides .slider-with-round-image-over__text-side').css('marginLeft');
    if ($(window).width() > 599) {
        $('.slider-with-round-image-over__slides .slick-prev').css('left', leftMargin);
        $('.slider-with-round-image-over__slides .slick-next').css('left', parseInt(leftMargin) + 48);
    }
}

$(document).ready(function () {
    $('.slider-with-round-image-over__slides').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        dotsClass: 'slick-dots list-no-bullets',
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
    });

    moveArrows();

    $('.slider-with-round-image-over__single-slide').each(function () {
        if ($(window).width() < 600) {
            $(this).find('.change-link-style-response').removeClass('link-with-icon-arrows').addClass('button-dinos button-dinos--full-width button-dinos--biger');
        } else {
            $(this).find('.change-link-style-response').removeClass('button-dinos button-dinos--full-width button-dinos--biger').addClass('link-with-icon-arrows');
        }
    });
});

$(window).on('resize', function () {
    moveArrows();
});